/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/meeting-api/public';
}

/**
 * Parameters for `MeetingApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
